/** True when a failed send is likely transient (offline / network), not a 4xx/5xx API error. */
export function isNetworkError(error: unknown): boolean {
  if (error instanceof TypeError) {
    const message = error.message.toLowerCase();
    return (
      message.includes('failed to fetch') ||
      message.includes('network') ||
      message.includes('load failed')
    );
  }

  if (error && typeof error === 'object') {
    const record = error as { name?: string; message?: string; code?: string };
    if (record.name === 'AbortError') return true;
    if (record.code === 'ECONNABORTED' || record.code === 'ENOTFOUND') return true;
    const message = record.message?.toLowerCase() ?? '';
    if (message.includes('network') || message.includes('failed to fetch')) {
      return true;
    }
  }

  return false;
}

export function isBrowserOnline(): boolean {
  if (typeof navigator === 'undefined') return true;
  return navigator.onLine !== false;
}
